module.exports = __webpack_public_path__ + "img/12228@3x.fdb04630.png";